import React from 'react'

function IconFlagFilled() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7713 3.07295L7.45612 0.532709C7.32875 0.482912 7.17601 0.482912 7.04863 0.582507C6.92127 0.657281 6.87035 0.781691 6.87035 0.931236V11.4159C4.62978 11.5154 3 12.3621 3 13.4579C3 14.6283 4.83345 15.5 7.27772 15.5C9.72229 15.5 11.5554 14.6283 11.5554 13.4579C11.5554 12.3621 9.92583 11.5154 7.68493 11.4158L7.68509 5.56316L13.6945 3.8448C13.8728 3.79501 14 3.64562 14 3.47125C14.0002 3.29689 13.9237 3.12268 13.771 3.07288L13.7713 3.07295ZM10.7156 13.4577C10.7156 13.9558 9.39148 14.6531 7.27794 14.6531C5.18994 14.6531 3.84029 13.9308 3.84029 13.4577C3.84029 13.0094 4.9861 12.3619 6.84508 12.2623V13.881H7.7108V12.2623C9.56978 12.3619 10.7156 13.0094 10.7156 13.4577V13.4577Z" fill="#836F50" />
    </svg>
  )
}
export default IconFlagFilled
